import request from '@/utils/request'

export function getCategoryList() {
  return request({
    url: '/wx/catalog/all',
    method: 'get'
  })
}

export function catelogIndex(query) {
  return request({
    url: '/wx/catalog/index',
    method: 'get',
    params: query
  });
}



// WEBPACK FOOTER //
// ./src/api/category/category.js